"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getContractAddressesForChainOrThrow = exports.contracts = exports.ChainId = void 0;
const ethers_1 = require("ethers");
const goerli_json_1 = __importDefault(require("../deployments/goerli.json"));
const mainnet_json_1 = __importDefault(require("../deployments/mainnet.json"));
var ChainId;
(function (ChainId) {
    ChainId[ChainId["EthereumMainnet"] = 1] = "EthereumMainnet";
    ChainId[ChainId["EthereumGoerli"] = 5] = "EthereumGoerli";
    ChainId[ChainId["EthereumHardhat"] = 31337] = "EthereumHardhat";
})(ChainId || (exports.ChainId = ChainId = {}));
exports.contracts = {
    [ChainId.EthereumGoerli]: {
        evm: {
            prophouse: goerli_json_1.default.ethereum.address.propHouse,
            messenger: goerli_json_1.default.ethereum.address.messenger,
            house: {
                community: goerli_json_1.default.ethereum.address.communityHouseImpl,
            },
            round: {
                infinite: goerli_json_1.default.ethereum.address.infiniteRoundImpl,
                timed: goerli_json_1.default.ethereum.address.timedRoundImpl,
            },
            starknetCommit: goerli_json_1.default.ethereum.address.starknetCommit,
        },
        starknet: {
            roundFactory: goerli_json_1.default.starknet.address.roundFactory,
            strategyRegistry: goerli_json_1.default.starknet.address.strategyRegistry,
            blockRegistry: goerli_json_1.default.starknet.address.ethBlockRegistry,
            govPower: {
                allowlist: goerli_json_1.default.starknet.address.allowlistGovPowerStrategy,
                balanceOf: goerli_json_1.default.starknet.address.ethBalanceOfGovPowerStrategy,
                balanceOfErc20: goerli_json_1.default.starknet.address.ethBalanceOfErc20GovPowerStrategy,
                balanceOfErc1155: goerli_json_1.default.starknet.address.ethBalanceOfErc1155GovPowerStrategy,
                checkpointableErc721: goerli_json_1.default.starknet.address.ethCheckpointableErc721GovPowerStrategy,
                vanilla: goerli_json_1.default.starknet.address.vanillaGovPowerStrategy,
            },
            auth: {
                infinite: {
                    sig: goerli_json_1.default.starknet.address.infiniteRoundEthSigAuthStrategy,
                    tx: goerli_json_1.default.starknet.address.infiniteRoundEthTxAuthStrategy,
                },
                timed: {
                    sig: goerli_json_1.default.starknet.address.timedRoundEthSigAuthStrategy,
                    tx: goerli_json_1.default.starknet.address.timedRoundEthTxAuthStrategy,
                },
            },
            herodotus: {
                factRegistry: goerli_json_1.default.starknet.address.herodotus.factRegistry,
                l1HeadersStore: goerli_json_1.default.starknet.address.herodotus.l1HeadersStore,
            },
            classHashes: {
                infinite: goerli_json_1.default.starknet.classHash.infiniteRound,
                timed: goerli_json_1.default.starknet.classHash.timedRound,
            },
        },
    },
    [ChainId.EthereumMainnet]: {
        evm: {
            prophouse: mainnet_json_1.default.ethereum.address.propHouse,
            messenger: mainnet_json_1.default.ethereum.address.messenger,
            house: {
                community: mainnet_json_1.default.ethereum.address.communityHouseImpl,
            },
            round: {
                infinite: ethers_1.constants.HashZero,
                timed: mainnet_json_1.default.ethereum.address.timedRoundImpl,
            },
            starknetCommit: mainnet_json_1.default.ethereum.address.starknetCommit,
        },
        starknet: {
            roundFactory: mainnet_json_1.default.starknet.address.roundFactory,
            strategyRegistry: mainnet_json_1.default.starknet.address.strategyRegistry,
            blockRegistry: mainnet_json_1.default.starknet.address.ethBlockRegistry,
            govPower: {
                allowlist: mainnet_json_1.default.starknet.address.allowlistGovPowerStrategy,
                balanceOf: mainnet_json_1.default.starknet.address.ethBalanceOfGovPowerStrategy,
                balanceOfErc20: mainnet_json_1.default.starknet.address.ethBalanceOfErc20GovPowerStrategy,
                balanceOfErc1155: mainnet_json_1.default.starknet.address.ethBalanceOfErc1155GovPowerStrategy,
                checkpointableErc721: mainnet_json_1.default.starknet.address.ethCheckpointableErc721GovPowerStrategy,
                vanilla: ethers_1.constants.HashZero,
            },
            auth: {
                infinite: {
                    sig: ethers_1.constants.HashZero,
                    tx: ethers_1.constants.HashZero,
                },
                timed: {
                    sig: mainnet_json_1.default.starknet.address.timedRoundEthSigAuthStrategy,
                    tx: mainnet_json_1.default.starknet.address.timedRoundEthTxAuthStrategy,
                },
            },
            herodotus: {
                factRegistry: mainnet_json_1.default.starknet.address.herodotus.factRegistry,
                l1HeadersStore: mainnet_json_1.default.starknet.address.herodotus.l1HeadersStore,
            },
            classHashes: {
                infinite: ethers_1.constants.HashZero,
                timed: mainnet_json_1.default.starknet.classHash.timedRound,
            },
        },
    },
};
/**
 * Get addresses of contracts that have been deployed to a supported chain.
 * Throws if there are no known contracts deployed on the corresponding chain.
 * @param chainId The desired chainId
 */
const getContractAddressesForChainOrThrow = (chainId) => {
    if (!exports.contracts[chainId]) {
        throw new Error(`Unknown chain id (${chainId}). No known contracts have been deployed on this chain.`);
    }
    return exports.contracts[chainId];
};
exports.getContractAddressesForChainOrThrow = getContractAddressesForChainOrThrow;
